import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { dict } from '../lib/i18n';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('en');

  useEffect(() => {
    let saved = null;
    try { saved = localStorage.getItem('nathanael_lang'); } catch (_) {}
    const browser = (navigator.language || 'en').toLowerCase();
    const initial = saved || (browser.startsWith('es') ? 'es' : 'en');
    setLang(initial);
    document.documentElement.lang = initial;
  }, []);

  const change = useCallback((next) => {
    setLang(next);
    document.documentElement.lang = next;
    try { localStorage.setItem('nathanael_lang', next); } catch (_) {}
  }, []);

  const t = useCallback((key, vars) => {
    let s = (dict[lang] && dict[lang][key]) || (dict.en && dict.en[key]) || key;
    if (vars) Object.keys(vars).forEach(k => { s = s.replaceAll(`{${k}}`, vars[k]); });
    return s;
  }, [lang]);

  const value = { lang, setLang: change, t };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLang must be used inside LanguageProvider');
  return ctx;
};
